import React from 'react';
import { Icon, UnstyledButton } from '@shopify/polaris';
import { CaretDownMinor } from '@shopify/polaris-icons';
import { classNames } from '@shopify/css-utilities';
import styles from './Button.scss.mjs';
import { Icon as Icon$1 } from '../Icon/Icon.mjs';

function Button({
  children,
  icon,
  disclosure,
  pressed,
  bordered,
  disabled,
  ...rest
}) {
  const iconMarkup = icon && /*#__PURE__*/React.createElement(Icon$1, {
    source: icon,
    disabled: disabled
  });
  const diclosureMarkup = disclosure && /*#__PURE__*/React.createElement("div", {
    className: styles.Disclosure
  }, /*#__PURE__*/React.createElement(Icon, {
    source: CaretDownMinor,
    tone: "base"
  }));
  const buttonClassNames = classNames(styles.Button, pressed && styles.pressed, icon && styles.icon, bordered && styles.bordered, disabled && styles.disabled);
  return /*#__PURE__*/React.createElement(UnstyledButton, Object.assign({
    className: buttonClassNames,
    disabled: disabled,
    pressed: pressed
  }, rest), iconMarkup, children, diclosureMarkup);
}

export { Button };
